<template>
  <div>
    <div :class="$style.titleContainer">
      <div :class="$style.title">{{ label }}</div>
      <icon
        v-if="showInfo"
        @click.native="infoClicked"
        icon="info-filled"
        :class="$style.info"
      ></icon>
    </div>
    <p :class="$style.description">
      <slot></slot>
    </p>
  </div>
</template>

<script>
import icon from "../display/icon"

export default {
  name: "text-fragment",
  components: { icon },
  props: {
    label: { type: String, required: true },
    showInfo: { type: Boolean, default: false }
  },
  methods: {
    infoClicked() {
      this.$emit("info-clicked");
    }
  }
};
</script>

<style module lang="scss">
@import "../../style/modules/input.module";
</style>
